import React from "react";
import { Box } from "@chakra-ui/layout";
import { Flex, Heading } from "@chakra-ui/react";
import { Step, Steps } from "chakra-ui-steps";
import PopUpDetails from "./Steps/popupDetails";
import RescheduledDetails from "./Steps/rescheduledDetails";
import RescheduleDates from "./Steps/rescheduleDates";

export const RescheduleSessionStepper = ({
  title,
  session,
  activeStep,
  data,
  handleFormDataChange,
  message,
  type,
  calenderStartDate,
  handleCalendarChange,
  isRescheduled,
  setSelectedSlot,
  reschedulingPerson,
}) => {
  const steps = [
    {
      element: (
        <PopUpDetails
          title={title}
          message={message}
          session={session}
          type={type}
          reschedulingPerson={reschedulingPerson}
        />
      ),
    },
    {
      element: (
        <RescheduledDetails
          data={data}
          handleFormDataChange={handleFormDataChange}
          isRescheduled={isRescheduled}
          reschedulingPerson={reschedulingPerson}
        />
      ),
    },
    {
      element: (
        <RescheduleDates
          data={data}
          calenderStartDate={calenderStartDate}
          handleCalendarChange={handleCalendarChange}
          session={session}
          setSelectedSlot={setSelectedSlot}
        />
      ),
    },
  ];

  return (
    <Flex flexDir="column" width="100%" backgroundColor="white" pt="16px">
      <Steps
        variant="circles-alt"
        orientation="horizontal"
        responsive={false}
        colorScheme="blue"
        sx={{
          "& .css-eb100c": {
            _completed: {
              color: "white",
            },
            color: "unset",
          },
          "& .css-1emvh1t, .css-vv8cpc": {
            fontSize: "14px",
            fontFamily: "Inter",
            mt: "8px",
            lineHeight: "20px",
          },
          "& .css-yli7i8:not(:last-child):after": {
            top: "calc(45px/2)",
            // borderBottom: 'dashed',
          },
          "& .css-1j537u4[aria-current=step]": {
            backgroundColor: "#4299E1",
            color: "white",
            border: "none",
            textColor: "white",
          },
          "& .css-1j537u4": {
            height: "32px",
            width: "32px",
          },
        }}
        activeStep={activeStep}
      >
        {steps.map(({ label, element }, index) => (
          <Step label={label} key={index}>
            <Box sx={{ p: "4px" }}>
              <Heading
                sx={{
                  "& .chakra-form__required-indicator": {
                    color: "black",
                  },
                }}
                textAlign="center"
              >
                {element}
              </Heading>
            </Box>
          </Step>
        ))}
      </Steps>
    </Flex>
  );
};
